<div [class.fullscreen]="isFullScreen">
  <div class="ageing-trend-chart-component">
    <div class="upper-chart-heading">
      <div class="ltms-widget-title">
        {{upperChartName}}
        <div class="upper-chart-discription ltms-description">
          {{ upperChartDiscription }}
        </div>
      </div>
      <div class="right-upper-chart-options">
        <!-- <app-ltms-widget-tools [config]='widgetConfig' [elementId]="widgetConfig.elementId"
      (onTrendTypeChange)="onTrendTypeChange($event, false)"></app-ltms-widget-tools> -->
        <app-score-widget [config]="scoreWidget()" (onFullscreenClick)="onFullScreen($event)"
          (onTrendClick)="onTrendTypeChange($event, false)" (onDownloadClick)="onDownload()"></app-score-widget>
      </div>
    </div>
    <!-- <div class="upper-chart-discription ltms-description">
  {{ upperChartDiscription }}
  </div> -->
    <div *ngIf="isDataAvailable && isDataLoaded">
      <div class="line-chart">
        <app-ltms-line-chart-view [config]="chartData" [componentId]="chartId"
          (onSelect)="onChartClick($event)"></app-ltms-line-chart-view>
      </div>
    </div>
    <div *ngIf="!isDataAvailable && isDataLoaded">
      <app-ltms-error [code]="errorCode"></app-ltms-error>
    </div>
    <div class="data-details-loader" *ngIf="isDataLoaded == false">
      <app-ltms-loader></app-ltms-loader>
    </div>
  </div>
</div>